import { useEffect } from "react";

export const useRateTooltip = (rate) => {
  useEffect(() => {
    let tooltipEl = null;
    let currentTarget = null;

    const removeTooltip = () => {
      if (tooltipEl) {
        tooltipEl.classList.remove("tooltip-fade-in");
        tooltipEl.classList.add("tooltip-fade-out");

        const elToRemove = tooltipEl;
        tooltipEl = null;
        currentTarget = null;

        elToRemove.addEventListener(
          "transitionend",
          () => {
            elToRemove.remove();
          },
          { once: true }
        );
      }
    };

    const handleMouseOver = (e) => {
      const target = e.target;
      if (!target.closest(".cluster-ppc-auctions")) return;
      if (target === currentTarget) return;
      removeTooltip();
      if (target.tagName !== "SPAN") return;
      
      const text = target.textContent || "";
      if (!text.includes("$")) return;
      
      const match = text.match(/\$([0-9,.]+)/);
      if (!match) return;

      const amount = parseFloat(match[1].replace(/,/g, ""));
      if (isNaN(amount) || !rate || rate === 0) {
        console.log("No rate or amount is NaN", amount, rate);
        return;
      };

      const converted = (amount * rate).toFixed(2);
      const rect = target.getBoundingClientRect();

      tooltipEl = document.createElement("div");
      tooltipEl.innerHTML = `
        <div style="
          background: #000;
          color: white;
          padding: 6px 10px;
          border-radius: 6px;
          font-size: 13px;
          font-weight: 300;
          font-family: sans-serif;
          position: relative;
          box-shadow: 0 4px 10px rgba(0,0,0,0.4);
        ">
          €${converted}
          <div style="
            content: '';
            position: absolute;
            bottom: -6px;
            left: 50%;
            transform: translateX(-50%);
            width: 0;
            height: 0;
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-top: 6px solid #000;
          "></div>
        </div>
      `;

      tooltipEl.classList.add("tooltip-fade", "tooltip-fade-in");

      tooltipEl.style.position = "fixed";
      tooltipEl.style.top = `${rect.top - 40}px`;
      tooltipEl.style.left = `${rect.left + rect.width / 2}px`;
      tooltipEl.style.transform = "translateX(-50%)";
      tooltipEl.style.zIndex = "9999";
      tooltipEl.style.pointerEvents = "none";

      document.body.appendChild(tooltipEl);
      currentTarget = target;
    };

    const handleMouseOut = (e) => {
      if (e.target === currentTarget) {
        removeTooltip();
      }
    };

    document.addEventListener("mouseover", handleMouseOver);
    document.addEventListener("mouseout", handleMouseOut);

    return () => {
      document.removeEventListener("mouseover", handleMouseOver);
      document.removeEventListener("mouseout", handleMouseOut);
      removeTooltip();
    };
  }, [rate]);
};
